import PropTypes from 'prop-types';

export const imagePropType = PropTypes.shape({
  caption: PropTypes.string,
  photographer: PropTypes.string,
  image_id: PropTypes.string.isRequired,
});

export const authorPropType = PropTypes.shape({
  email: PropTypes.string,
  firstname: PropTypes.string.isRequired,
  lastname: PropTypes.string.isRequired,
  image: imagePropType,
  image2: imagePropType,
  title: PropTypes.string,
});

const videoShape = {
  supplier: PropTypes.oneOf([
    'facebook',
    'ireality',
    'vimeo',
    'youtube',
    'streamio',
  ]).isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  start_offset: PropTypes.number,
  image_id: PropTypes.string,
};

export const videoType = PropTypes.shape({
  ...videoShape,
});

export const paragraphTypes = [
  'accordion',
  'archive_image',
  'expandable_content',
  'fact_box',
  'html',
  'quote',
  'related_content',
  'video',
  'liveblog',
];

export const archiveImageType = PropTypes.shape({
  cdn_id: PropTypes.string.isRequired,
  photographer: PropTypes.string,
  caption: PropTypes.string,
});

export const paragraphArchiveImagesType = PropTypes.shape({
  images: PropTypes.arrayOf(archiveImageType).isRequired,
  type: PropTypes.oneOf(['archive_images']).isRequired,
});

export const paragraphExpandableContentType = PropTypes.shape({
  headline: PropTypes.string,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  type: PropTypes.oneOf(['expandable_content']).isRequired,
});

export const paragraphLiveBlogType = PropTypes.shape({
  type: PropTypes.oneOf(['liveblog']).isRequired,
  access: PropTypes.number.isRequired,
  id: PropTypes.string,
});

export const paragraphFactBoxType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['fact_box']).isRequired,
});

export const paragraphHtmlType = PropTypes.shape({
  content: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['html']).isRequired,
});

export const paragraphQuoteType = PropTypes.shape({
  byline: PropTypes.string,
  quote: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['quote']).isRequired,
});

export const paragraphRelatedArticleType = PropTypes.shape({
  content: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['related_content']).isRequired,
});

export const paragraphSponsorType = PropTypes.shape({
  header: PropTypes.string.isRequired,
  image: PropTypes.shape({
    caption: PropTypes.string,
    photographer: PropTypes.string,
    image_id: PropTypes.string.isRequired,
  }),
  text: PropTypes.string,
  type: PropTypes.oneOf(['sponsor_box']).isRequired,
});

export const paragraphVideoType = PropTypes.shape({
  ...videoShape,
  type: PropTypes.oneOf(['video']).isRequired,
});

export const betTypePropType = PropTypes.oneOf([
  'V75',
  'V86',
  'GS75',
  'V64',
  'V65',
  'V5',
  'V4',
  'V3',
  'TRIO',
  'DD',
  'LD',
]);
